/**
 * Created by Daniel on 6/27/2017.
 */
function openPopUp(e) {
	let matches = e.target.matches ? e.target.matches('.sojka__popup-trigger') : event.target.msMatchesSelector('.sojka__popup-trigger');
	if (!matches) return;
	const opener = e.target;
	const wrapper = opener.parentNode;
	const otherSojkaPopUps = document.querySelectorAll('.sojka__popup');
	for (let i = 0; i < otherSojkaPopUps.length; i++) { otherSojkaPopUps[i].classList.remove('is-opened'); }
	wrapper.classList.add('is-opened');
}

function closePopUp(e) {
	let matches = e.target.matches ? e.target.matches('.sojka__popup-close') : event.target.msMatchesSelector('.sojka__popup-close');
	if (!matches) return;
	const opener = e.target;
	const wrapper = opener.parentNode.parentNode;
	wrapper.classList.remove('is-opened');
}

document.addEventListener('click', (e) => closePopUp(e));
document.addEventListener('click', (e) => openPopUp(e));

const SojkaDetail = {

	isActive: false,

	getElementsDimensions(element) {
		return {
			width: $(element).width(),
			height: $(element).height()
		}
	},

	getElementsPosition(element) {
		return {
			offsetTop: $(element).offset().top,
			offsetLeft: $(element).offset().left
		}
	},
	positionSojkaPopup(trigger, popup) {
		const triggerPosition = this.getElementsPosition(trigger);
		const triggerDimensions = this.getElementsDimensions(trigger);

		const popupPosition = this.getElementsPosition(popup);

		const popupNewTop = (triggerPosition.offsetTop - popupPosition.offsetTop) + (triggerDimensions.height * 1) + 13;
		const popupNewLeft = (triggerPosition.offsetLeft - popupPosition.offsetLeft) - (triggerDimensions.width / 2 + 10);
		popup.css({
			'top': `${popupNewTop}px`,
			'left': `${popupNewLeft}px`,
			'right': 'auto'
		});

		// Correct position if popup overflows body boundaries
		var rect = popup[0].getBoundingClientRect();
		var bodyWidth = document.body.clientWidth;
		var curLeft = parseFloat(popup.css('left')) || 0;

		if (rect.left < 0) {
			popup.css('left', curLeft - rect.left);
		} else if (rect.right > bodyWidth) {
			popup.css('left', Math.max(0, curLeft - (rect.right - bodyWidth)));
		}
	},

	hackInitialTrigger(element) {
		$(element).removeClass('active');
		$(element).find('.tip').remove();
		$('#sojka-hlavni')[0].click();
	},

	init() {
		const $sojkaProductTypeTrigger = $('.product__type-watch');
		if (!$sojkaProductTypeTrigger.length) return;

		const $sojkaTrigger = $('#sojka-hlavni');
		const $sojkaPopup = $sojkaTrigger.next('.pop-up__content');
		const $sojkaContent = $sojkaPopup.find('.pop-up__main');

		const popupStyle = $sojkaPopup.attr('style');
		const resetSojkaPosition = function () {
			$sojkaPopup.attr('style', popupStyle);
		}

		const _this = this;
		$sojkaProductTypeTrigger.on('click', function (e) {
			e.preventDefault();

			if ($sojkaTrigger.parents('.pop-up').hasClass('pop-up--active')) {
				e.stopPropagation();
				return;
			}

			const $this = $(this);

			setTimeout(() => {
				_this.hackInitialTrigger($this);
				resetSojkaPosition();
				_this.positionSojkaPopup($this, $sojkaPopup);
			}, 50);

		});

		$sojkaContent.on('click', (e) => {
			e.stopPropagation();
		})
	}
};

SojkaDetail.init();